import {PostOdontoCancel} from 'domain/usecases';
import {RemotePostOdontoCancel} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostOdontoCancelBooked = (): PostOdontoCancel =>
	new RemotePostOdontoCancel(
		makeBFFApiUrl(BookedFlowEndPoints.odontoCancel),
		makeAuthorizeHttpClientDecorator(),
	);
